import { t } from '../lib/i18n';

/**
 * The split screen the sign-in and sign-up pages share.
 *
 * The left panel is the only place in the product that sells anything, so it carries the brand and
 * the three things the platform does; the right panel is the form and nothing else. Keeping them in
 * one component means the two pages cannot drift apart.
 */
export function AuthLayout({ children }: { children: React.ReactNode }): React.JSX.Element {
  return (
    <div className="auth">
      <aside className="auth__aside" aria-hidden="true">
        <div className="auth__brand">
          <span className="auth__mark">SC</span>
          <span className="auth__wordmark">{t('app.name')}</span>
        </div>

        <div className="auth__pitch">
          <h2 className="auth__headline">
            {t('auth.hero.line')} <em>{t('auth.hero.highlight')}</em>
          </h2>

          <p className="auth__body">{t('auth.hero.body')}</p>

          <ul className="auth__points">
            <li>{t('auth.hero.point1')}</li>
            <li>{t('auth.hero.point2')}</li>
            <li>{t('auth.hero.point3')}</li>
          </ul>
        </div>

        <p className="auth__legal">
          © {new Date().getFullYear()} {t('app.name')} · {t('auth.hero.rights')}
        </p>
      </aside>

      <main className="auth__panel">
        {/* The brand repeats here for the narrow layout, where the aside is not rendered. */}
        <div className="auth__brand auth__brand--compact">
          <span className="auth__mark">SC</span>
          <span className="auth__wordmark">{t('app.name')}</span>
        </div>

        <div className="auth__form">{children}</div>
      </main>
    </div>
  );
}
